export default __webpack_public_path__ + "static/media/fun Target wheell.30e11a58.svg";